import { Box, Button, Flex, NumberInput } from "@mantine/core";
import { repositoryDelivery } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { useState } from "react";
import { IconCheck } from "@tabler/icons-react";

const ModalUpdateDeposit = ({ id }: { id: number }) => {
  const [dataSubmit, setDataSubmit] = useState<any>({
    DeliveryAssignmentDetailId: id,
    ParkingFee: 0,
  });

  const handleSubmit = async () => {
    if (
      dataSubmit?.ParkingFee < 0 ||
      dataSubmit?.ParkingFee === null ||
      dataSubmit?.ParkingFee === undefined
    ) {
      NotificationExtension.Fails(
        "Tiền gửi xe sai định dạng hoặc đang bị âm !"
      );
    } else {
      try {
        const response = await repositoryDelivery.post(
          `api/v1/TblDeliveryAssignment/update-parking-fee`,
          { ...dataSubmit, ParkingFee: Number(dataSubmit?.ParkingFee * 1000) }
        );
        if (response && response.success) {
          NotificationExtension.Success("Cập nhật tiền gửi xe thành công");
          modals.closeAll();
        }
      } catch (error) {
        console.log("error", error);
        NotificationExtension.Fails("Cập nhật tiền gửi xe thất bại");
      }
    }
  };

  return (
    <Box mt={10}>
      <NumberInput
        label="Tiền gửi xe"
        placeholder="Nhập tiền gửi xe"
        value={Number(dataSubmit?.ParkingFee)}
        allowNegative={false}
        onChange={(e) =>
          setDataSubmit((prev: any) => ({
            ...prev,
            ParkingFee: e,
          }))
        }
        hideControls
        thousandSeparator=" "
        suffix={
          dataSubmit.ParkingFee === 0 || !dataSubmit.ParkingFee
            ? " VNĐ"
            : " 000 VNĐ"
        }
      />

      <Flex mt={10} justify={"end"}>
        <Button
          leftSection={<IconCheck size={14} />}
          onClick={() => handleSubmit()}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default ModalUpdateDeposit;
